import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const MeetingRoomIcon40 = (props: SvgProps) => <Svg
  width='40'
  height='40'
  viewBox='0 0 40 40'
  fill='none'
  {...props}
>
  <Path
    d='M3.33333 11.666L4.87735 22.4741C4.94772 22.9668 5.36964 23.3327 5.86729 23.3327H15'
    stroke='#3379BD'
    strokeWidth='2'
    strokeLinecap='round'
  />
  <Path
    d='M37.3307 11.666L35.7867 22.4741C35.7163 22.9668 35.2944 23.3327 34.7968 23.3327H25.6641'
    stroke='#3379BD'
    strokeWidth='2'
    strokeLinecap='round'
  />
  <Path
    d='M30.9948 23.332V28.332M30.9948 28.332L26.8281 29.9987M30.9948 28.332L35.1615 29.9987'
    stroke='#3379BD'
    strokeWidth='2'
    strokeLinecap='round'
  />
  <Path
    d='M9.66536 23.332V28.332M9.66536 28.332L13.832 29.9987M9.66536 28.332L5.4987 29.9987'
    stroke='#3379BD'
    strokeWidth='2'
    strokeLinecap='round'
  />
  <Path
    d='M9.5 16.666H20.3333M31.1667 16.666H20.3333M20.3333 16.666V28.3327'
    stroke='#3379BD'
    strokeWidth='2'
    strokeLinecap='round'
  />
</Svg>;

export default MeetingRoomIcon40;
